import {
  compareMoney,
  formatMoneyDisplay,
  moneyUtilizationPercent,
  subtractMoneyStrings,
} from '../finance/financeMoney';
import './journey-cost.css';

/**
 * 預算進度條（百分比僅供顯示，金額以字串運算）。
 * @param {string} [usageLabel] 左側用量標籤，預設「已用」
 */
export default function CostBudgetProgress({
  spent,
  total,
  currency,
  usageLabel = '已用',
}) {
  const spentDisplay = formatMoneyDisplay(spent || '0');
  const totalDisplay = formatMoneyDisplay(total || '0');
  const remaining = subtractMoneyStrings(total || '0', spent || '0');
  const over = compareMoney(spent || '0', total || '0') > 0;
  const percent = moneyUtilizationPercent(spent || '0', total || '0');
  const currencyCode = currency ? String(currency) : '';

  return (
    <div
      className="journey-cost-budget-progress"
      data-testid="cost-budget-progress"
      role="group"
      aria-label={`預算進度 ${percent}%`}
    >
      <p className="journey-cost-budget-progress__label">
        <span>
          {usageLabel}
          {' '}
          {spentDisplay}
          {currencyCode ? ` ${currencyCode}` : ''}
          {' / '}
          {totalDisplay}
          {currencyCode ? ` ${currencyCode}` : ''}
        </span>
        <span>
          {percent}
          %
          {over
            ? '（已超出）'
            : ` · 剩餘 ${formatMoneyDisplay(remaining)}${currencyCode ? ` ${currencyCode}` : ''}`}
        </span>
      </p>
      <div className="journey-cost-budget-progress__track" aria-hidden="true">
        <div
          className={`journey-cost-budget-progress__fill${over ? ' is-over' : ''}`}
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
